import { env } from '@/env.mjs'
import { SendState } from '@/types'

interface GetStateProps {
  countryCode: string
  langCode: string
  offerID: string
  sekundId?: string
  authToken: string
  cancelLink?: string
  questionContent?: string
}

export const getState = (props: GetStateProps) => {
  const jsonData: SendState = {
    item: `${props.offerID}`,
    country_code: `${props.countryCode}`,
    lang_code: `${props.langCode}`,
    environment: env.NEXT_PUBLIC_ENV ? env.NEXT_PUBLIC_ENV : '',
    authToken: props.authToken,
    sekundId: props.sekundId,
  }
  if (props.questionContent) {
    jsonData.question = encodeURIComponent(props.questionContent)
  } else if (props.cancelLink) {
    jsonData.reserved = 'true'
    jsonData.cancelLink = props.cancelLink
  } else {
    jsonData.canceled = 'true'
  }

  return window.btoa(JSON.stringify(jsonData))
}
